import { Box } from '@mui/material';
import Color from 'color';
import React from 'react';

const Alpha = ({ color }: { color: string }) => (
	<Box paddingY={1} paddingX={2} width={70}>
		{Math.round(Color(color).alpha() * 100)}%
	</Box>
);

export default Alpha;
